export const IMAGE_UPCASED_TYPE = 'Image';
export const IMAGE_TAG_NAME = 'img';
export const IMAGE_CAPTION_TAG_NAME = 'figcaption';

const JPEG = 'image/jpeg';
const JPG = 'image/jpg';
const PNG = 'image/png';

export const ACCEPTED_FILES = `${JPEG},${JPG},${PNG}`;
export const MAX_SIZE = 10000000;
